import { Injectable } from '@angular/core';
import { BaseService } from 'cre-ng';
import { WigAwardsEnroll } from './wig-awards-enroll.model';
import { WigAwardsSummary } from './wig-awards-summary.model';

@Injectable()
export class WigAwardsService extends BaseService {
  getWigAwardsSummary(
    driver: string,
    month: Date,
    earnedPointsStartDate: Date,
    earnedPointsEndDate: Date
  ): Promise<WigAwardsSummary> {
    const monthValue = this.formatDate(month);
    const earnedPointsStartDateValue = this.formatDate(earnedPointsStartDate);
    const earnedPointsEndDateValue = this.formatDate(earnedPointsEndDate);

    const url =
      this.serviceUrl +
      `api/v1/awards/${driver}/summary` +
      `?month=${monthValue}` +
      `&startDate=${earnedPointsStartDateValue}&endDate=${earnedPointsEndDateValue}`;
    const httpHeaders = this.getHttpHeaders();
    const requestOptions = { headers: httpHeaders };
    return this.httpClient.get<WigAwardsSummary>(url, requestOptions).toPromise();
  }

  enroll(
    driver: string,
    currentLevelStatus?: string,
    usingPreviousYear?: boolean
  ): Promise<WigAwardsEnroll[]> {
    let url = this.serviceUrl + `enroll?DriverCode=${driver}`;
    if (usingPreviousYear) {
      url += `&UsingPreviousYear=${usingPreviousYear}`;
    }
    if (currentLevelStatus) {
      url += `&CurrentLevelStatus=${currentLevelStatus}`;
    }
    const httpHeaders = this.getHttpHeaders();
    const requestOptions = { headers: httpHeaders };
    return this.httpClient.post<WigAwardsEnroll[]>(url, {}, requestOptions).toPromise();
  }

  private formatDate(d: Date) {
    const month = d.getMonth() + 1;
    return `${d.getFullYear()}-${month < 10 ? `0${month}` : month}-01`;
  }

  protected getEndPoint(): string {
    return '/safeandontime/';
  }
}
